import BaseQuery from "../common/BaseQuery";

export default class EventParams extends BaseQuery {
    static get(id, lang, successCb, errCb) {

        let params = {
            p: 'api',
            op: 'remote',
            lang: !!lang ? lang : 'ru',
            id: id
        };

        EventParams.queryGet(params, (data) => successCb(data.data), errCb);
    }

    static paramNames() {
        return [
            'banner_file',
            'background_file',
            'event_name',
            'google_video_id',
            'streams',
            'google_video_params',
            'video_provider',
            'is_quiz_enabled',
            'is_chat_enabled',
            'quiz_id',
            'event_id',
            'room_font_color',
            'counterUrl',
            'is_after_event_quiz'
        ];
    }
}

